import { H5 } from "@sellar-io/components";
import { ReactElement, useState } from "react";
import { useSearchParams } from "react-router";
import type { StockListResponseType } from "@sellar-io/api-v2/types";
import { useBasketContext } from "../../../../hooks";
import { useSellarCurrentBusiness } from "../../../../hooks/useSellarCurrentBusiness.shared";
import { useSignupContext } from "../../../../hooks/useSignupContext.shared";
import { useStockListBasketValue } from "../../useStockListBasketValue";
import { useStockListContext } from "../../useStockListContext";
import { ItemQuantity } from "../ItemQuantity";
import CategoryListElementMobile from "./CategoryListElementMobile";

export default function CategoryListElementMobileContainer({
  category,
  hasDefaultPriceTier,
}: {
  category: StockListResponseType[number];
  hasDefaultPriceTier: boolean;
}): ReactElement {
  const {
    supplierQuery,
    connection,
    supplierStorefront,
    checkoutSelectedFulfillmentType,
    courierFulfillmentType,
  } = useStockListContext();
  const { business } = useSellarCurrentBusiness();
  const [{ order }] = useBasketContext();
  const [searchParams] = useSearchParams();
  const storefrontLink =
    searchParams.get("storefrontLink") || searchParams.get("priceTierLink");
  const { setSignupDialogActive, setBasketTotal } = useSignupContext();
  const basketTotal = useStockListBasketValue();
  const [selectedProductId, setSelectedProductId] = useState<number>();
  const selectedProduct = category.Products.find(
    (product) => product.id === selectedProductId,
  );

  const getSelectedFulfilmentType = () => {
    if (checkoutSelectedFulfillmentType) {
      return checkoutSelectedFulfillmentType;
    }

    if (connection?.fulfillmentType) {
      return connection.fulfillmentType;
    }

    return "courier";
  };

  const isBuyerAndHasConnectionOrDefaultPriceTier =
    business?.Retailer && (connection || hasDefaultPriceTier);
  const hasPricing = !!storefrontLink && !!selectedProduct?.ProductPriceTier;
  return (
    <CategoryListElementMobile
      category={category}
      supplier={supplierQuery.data}
      onClick={(productId) => setSelectedProductId(productId)}
      fulfillmentTypeContainerDeliveryCharges={
        supplierStorefront?.FulfillmentType
          .FulfillmentTypeContainerDeliveryCharges
      }
      order={order}
      selectedFulfillmentType={getSelectedFulfilmentType()}
      courierFulfillmentType={courierFulfillmentType}
    >
      {selectedProduct && (
        <>
          {isBuyerAndHasConnectionOrDefaultPriceTier || hasPricing ? (
            <div>
              <ItemQuantity
                productItem={selectedProduct}
                showMaxQuantity={true}
                selectedFulfillmentType={getSelectedFulfilmentType()}
              />
            </div>
          ) : (
            <H5
              onClick={() => {
                setBasketTotal(basketTotal);
                setSignupDialogActive(true);
              }}
            >
              {storefrontLink
                ? "Sign up to order"
                : hasDefaultPriceTier
                  ? "See pricing"
                  : "Request pricing"}
            </H5>
          )}
        </>
      )}
    </CategoryListElementMobile>
  );
}
